
import { Vue, Component } from 'vue-property-decorator';
import CutoffForm from '@/features/cutoff-times/components/CutoffForm.vue';
import CutoffResults from '@/features/cutoff-times/components/CutoffResults.vue';
import {
  CutoffTimesResponse,
  TransformedCutoffTimesItem,
} from '@/features/cutoff-times/types';
import { getCutoffTimes } from '@/features/cutoff-times/services/cutoff-times.services';

export interface CutoffTimesFormData {
  countryCode: string,
  postalCode: string,
}

@Component({
  components: {
    CutoffForm,
    CutoffResults,
  },
})
export default class CutoffTimes extends Vue {
  private formData: CutoffTimesFormData = {
    countryCode: '',
    postalCode: '',
  }

  private isLoading = false;

  private showResults = false;

  private results: CutoffTimesResponse = []

  get transformedCutoffTimes(): TransformedCutoffTimesItem[] {
    const pickupNotAvailableTime = '12:00 AM';

    const output: TransformedCutoffTimesItem[] = [];
    const sortedResults = this.results.filter((item) => item.cutoffTime !== pickupNotAvailableTime);

    sortedResults.push(
      ...this.results.filter((item) => item.cutoffTime === pickupNotAvailableTime),
    );

    sortedResults.forEach((result) => {
      if (output.some(({ carrierCode }) => carrierCode === result.carrierCode)) return;

      const allCarrierCodeResults = this.results
        .filter(({ carrierCode }) => carrierCode === result.carrierCode);

      const selectedServices = allCarrierCodeResults
        .map(({ serviceName, cutoffTime }) => (
          {
            name: serviceName,
            cutoffTime,
            isPickupAvailable: cutoffTime !== pickupNotAvailableTime,
          }
        ));

      output.push({
        carrierCode: result.carrierCode,
        selectedService: result.selectedService,
        selectedServices,
      });
    });

    return output;
  }

  private handleSubmit(): void {
    this.results = [];
    this.getCutoffTimes();
  }

  private handleReset(): void {
    this.showResults = false;
    this.results = [];
  }

  private async getCutoffTimes(): Promise<void> {
    this.showResults = false;
    this.isLoading = true;
    this.results = await getCutoffTimes(this.formData.countryCode, this.formData.postalCode);
    this.isLoading = false;
    this.showResults = true;
  }
}
